import { CheckCircleFilled } from '@ant-design/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { rupiah } from 'src/actions/rupiah';
import styled, { css } from 'styled-components';

/* ---------------- Styled Components ---------------- */

const ACCENT = '#FF0F51';

const Card = styled.div`
  width: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  cursor: pointer;
  user-select: none;

  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${ACCENT};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  ${(props) =>
    props.selected &&
    css`
      border-color: ${ACCENT};
      border-bottom-width: 8px;
      background: #ffe3ec; /* soft accent background */
      &:hover {
        border-color: ${ACCENT};
      }
    `}
`;

const CardTitle = styled.h3`
  margin-bottom: 4px;
  font-size: 1.125rem;
  font-weight: 600;
`;

const CardDuration = styled.p`
  margin-bottom: 8px;
  font-weight: 500;
  color: ${ACCENT};
`;

const Price = styled.p`
  margin-bottom: 16px;
  font-size: 1.125rem;
  font-weight: 700;
`;

const BenefitList = styled.ul`
  margin-bottom: 16px;
  list-style: none;
  padding: 0;

  li {
    display: flex;
    align-items: start;
    gap: 8px;
    font-size: 0.875rem;
    color: #374151;
  }
`;

export default function InfoActiveSubs() {
  const userData = useSelector((state) => state.profile_data);

  const packageSub = userData?.mes_subscription ?? '';

  if (!packageSub?.is_active) {
    return '';
  }

  return (
    <div>
      <Card selected={true}>
        <div>
          <CardTitle>{packageSub?.package?.name}</CardTitle>
          <CardDuration>
            {packageSub?.package?.duration_in_month} Bulan ({packageSub?.remaining_days} Hari
            Tersisa)
          </CardDuration>
          <Price>{rupiah(packageSub?.package?.price ?? 0)}</Price>

          <BenefitList>
            {packageSub?.package?.description_array.map((b, i) => (
              <li key={i}>
                <CheckCircleFilled style={{ color: ACCENT, fontSize: 18 }} />
                <span>{b}</span>
              </li>
            ))}
          </BenefitList>
        </div>
      </Card>
    </div>
  );
}
